export default class History {
    constructor() {
        this.slider = document.querySelector('.history-slider');

        if (window.innerWidth >= 1024) {
            this.slider.querySelectorAll('.last').forEach((el) => {
                el.classList.add('slider__item')
            })
        }
    }

}